import type { ReactNode } from 'react';

import {
  getSpartanRevealElementProps,
  SPARTAN_REVEAL_PRESET,
  SPARTAN_REVEAL_ROLE,
} from '@/app/lcv/components/sections/spartan/products/shared/reveal';
import styles from '@/app/lcv/components/sections/spartan/products/shared/section-header/styles.module.css';
// TextReveal path disabled — restore import + branch below to re-enable.
// import { SpartanProductSectionHeaderTextReveal } from '@/app/lcv/components/sections/spartan/products/shared/section-header/text-reveal';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

type RenderSpartanProductSectionTitleParams = {
  title: string;
  titleLead?: string;
  titleClassName: string;
  titleLeadClassName: string;
  titleRevealOrder: number;
  // isTextRevealEnabled: boolean;
  titleTestId: string;
};

const renderStackedTitleContent = (
  titleLead: string,
  title: string,
  titleLeadClassName: string
): ReactNode => (
  <>
    <span className={titleLeadClassName}>{titleLead}</span>
    <span
      className={styles.bodyLine}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  </>
);

export const renderSpartanProductSectionTitle = ({
  title,
  titleLead,
  titleClassName,
  titleLeadClassName,
  titleRevealOrder,
  // isTextRevealEnabled,
  titleTestId,
}: RenderSpartanProductSectionTitleParams) => {
  const stackedContent =
    titleLead?.trim() && title.trim()
      ? renderStackedTitleContent(titleLead.trim(), title, titleLeadClassName)
      : null;

  // if (isTextRevealEnabled) {
  //   if (stackedContent) {
  //     return (
  //       <SpartanProductSectionHeaderTextReveal
  //         as="h2"
  //         className={titleClassName}
  //         testId={titleTestId}
  //       >
  //         {stackedContent}
  //       </SpartanProductSectionHeaderTextReveal>
  //     );
  //   }
  //
  //   return (
  //     <SpartanProductSectionHeaderTextReveal
  //       as="h2"
  //       className={titleClassName}
  //       html={title}
  //       testId={titleTestId}
  //     />
  //   );
  // }

  if (stackedContent) {
    return (
      <h2
        className={titleClassName}
        {...getSpartanRevealElementProps({
          order: titleRevealOrder,
          preset: SPARTAN_REVEAL_PRESET.content,
          role: SPARTAN_REVEAL_ROLE.copy,
        })}
        {...createDataAttributes({ test: titleTestId })}
      >
        {stackedContent}
      </h2>
    );
  }

  return (
    <h2
      className={cn(titleClassName)}
      dangerouslySetInnerHTML={{ __html: title }}
      {...getSpartanRevealElementProps({
        order: titleRevealOrder,
        preset: SPARTAN_REVEAL_PRESET.content,
        role: SPARTAN_REVEAL_ROLE.copy,
      })}
      {...createDataAttributes({ test: titleTestId })}
    />
  );
};
